<template>
  <!-- 社群授权配置 -->
  <div>
    <SpCardContent title="客户联系API授权设置">
      <el-form
        ref="form"
        :model="form"
        label-width="150px"
        label-position="left"
      >
        <el-form-item label="Secret：">
          <el-input
            v-model="form.secret"
            style="width: 300px"
            placeholder="请填写内容"
          />
          <div class="tips">
            企业微信的客户联系凭证密钥，获取方式参考
            <a
              href="https://work.weixin.qq.com/api/doc#90000/90135/90665/secret"
              target="_blank"
            >术语说明-secret</a>
          </div>
        </el-form-item>
        <el-form-item label="Token：">
          <el-input
            v-model="form.token"
            style="width: 300px"
            placeholder="请填写内容"
          />
          <div class="tips">
            <a
              href="https://work.weixin.qq.com/api/doc#90000/90135/91440"
              target="_blank"
            >客户联系Token</a>
          </div>
        </el-form-item>
        <el-form-item label="EncodingAESKey：">
          <el-input
            v-model="form.aes_key"
            style="width: 300px"
            placeholder="请填写内容"
          />
          <div class="tips">
            <a
              href="https://work.weixin.qq.com/api/doc#90000/90135/91440"
              target="_blank"
            >客户联系EncodingAESKey</a>
          </div>
        </el-form-item>
      </el-form>
    </SpCardContent>

    <div class="fotter-toolbar">
      <el-button
        type="primary"
        :loading="loading"
        @click="onSubmit"
      >
        保存设置
      </el-button>
    </div>
  </div>
</template>

<script>
import { getMembership, setMembership } from '@/api/membership/membershipImpower'
export default {
  data () {
    return {
      loading: false,
      form: {
        secret: '',
        token: '',
        aes_key: ''
      }
    }
  },
  mounted () {
    this.getSetting()
  },
  methods: {
    // 保存设置数据
    async onSubmit () {
      this.loading = true
      const data = await setMembership(this.form).catch(() => {
        this.loading = false
      })
      if (data) {
        this.loading = false
        this.$message({
          message: '保存成功',
          type: 'success'
        })
      }
    },
    // 获取设置数据
    async getSetting () {
      const data = await getMembership()
      if (data) {
        this.form = data
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  width: 700px;
}
.wechat-top {
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-card {
  margin-bottom: 20px;
}
</style>
